<div class="position-fixed fixed-btn">
  <a (click)="showCartDialog()" class="btn btn-success btn-lg rounded-pill">
    <i class="fa fa-shopping-basket "></i>
    <span class="amount">{{total | appCurrency }}</span>
  </a>
</div>
